import React, { Component } from "react";
import { Link } from "react-router-dom";
import { isNotValue } from "../../utils/general";
import "./Style.css";

type Action = {
  label: string;
  handleClick?: () => void;
  href?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  rel?: string;
  triggerInterval?: number; // TODO: implement
  disabled?: boolean;
};

type Props = {
  label?: string;
  labelClassName?: string;
  topHeaderClassName?: string;
  labelAction?: () => void;
  labelHref?: string;
  topRightAction?: Action;
  isTopArea?: boolean;
  bottomAction?: Action;
  children: React.ReactNode;
};

type State = {};

class ContentArea extends Component<Props, State> {
  render() {
    const contentClasses = this.props.isTopArea ? "content top" : "content";

    return (
      <div className="content-area">
        <div className={contentClasses}>
          {this.renderTopHeader()}
          {this.props.children}
          <div className="bottom">{this.renderButton()}</div>
        </div>
      </div>
    );
  }

  renderTopHeader = () => {
    if (isNotValue(this.props.topRightAction)) {
      return this.renderLabel();
    }

    const topHeaderClass = this.props.topHeaderClassName
      ? `top-header ${this.props.topHeaderClassName}`
      : "top-header";

    return (
      <div className={topHeaderClass}>
        {this.renderLabel()}
        {this.renderTopRightAction()}
      </div>
    );
  };

  renderLabel = () => {
    const { label, labelAction, labelClassName, labelHref } = this.props;
    const normalizedLabel = label?.trim() ?? "";
    const labelClass = labelClassName ? `label ${labelClassName}` : "label";

    if (!normalizedLabel && isNotValue(labelAction) && isNotValue(labelHref)) {
      return null;
    }

    if (isNotValue(labelAction) && isNotValue(labelHref)) {
      return <div className={labelClass}>{normalizedLabel}</div>;
    }

    if (labelHref) {
      if (this.isExternalHref(labelHref)) {
        return (
          <a href={labelHref} className={`${labelClass} label-link hashrate-link`}>
            {normalizedLabel}
          </a>
        );
      }

      return (
        <Link to={labelHref} className={`${labelClass} label-link hashrate-link`}>
          {normalizedLabel}
        </Link>
      );
    }

    return (
      <button
        type="button"
        className={`${labelClass} label-link label-action-button`}
        onClick={labelAction}
      >
        {normalizedLabel}
      </button>
    );
  };

  renderButton = () => {
    if (!this.props.bottomAction) {
      return;
    }

    const { label, handleClick, disabled } = this.props.bottomAction;
    console.log("Disabled: " + disabled);
    return (
      <button
        className={disabled ? "disabled" : ""}
        onClick={handleClick}
        disabled={disabled}
      >
        {label}
      </button>
    );
  };

  renderTopRightAction = () => {
    if (!this.props.topRightAction) {
      return;
    }

    const { label, handleClick, href, target, rel, disabled } = this.props.topRightAction;
    const className = `top-right-action-link ${disabled ? "disabled" : ""}`.trim();

    if (disabled) {
      return (
        <span className={className} aria-disabled>
          {label}
        </span>
      );
    }

    if (href) {
      if (this.isExternalHref(href)) {
        return (
          <a className={`${className} hashrate-link`} href={href} target={target} rel={rel}>
            {label}
          </a>
        );
      }

      return (
        <Link className={`${className} hashrate-link`} to={href}>
          {label}
        </Link>
      );
    }

    return (
      <button
        type="button"
        className={`${className} top-right-action-button`.trim()}
        onClick={handleClick}
      >
        {label}
      </button>
    );
  };

  isExternalHref = (href: string) => /^(https?:)?\/\//.test(href);
}

export default ContentArea;
